import { render } from "./compositionEditor.vue?vue&type=template&id=61ad6bdb&scoped=true&ts=true"
import script from "./compositionEditor.vue?vue&type=script&lang=ts"
export * from "./compositionEditor.vue?vue&type=script&lang=ts"

import "./compositionEditor.vue?vue&type=style&index=0&id=61ad6bdb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ad6bdb"]])

export default __exports__